import { Input as AntInput, InputProps } from 'antd'
import { useFormatData } from 'hooks'
import { ReactNode, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { NOT_NUMBER_COMMA } from 'utils/regularExpressions'

const StyledInput = styled(AntInput)<{
  $preventInput?: boolean
  $defaultStyled?: boolean
}>`
  ${({ $defaultStyled }) =>
    $defaultStyled
      ? ''
      : `
  :focus {
    border: none;
    border-bottom: 1px solid var(--color-primary-109);
    border-radius: 0;
    box-shadow: none;
  }
  height: 36px;
  border: none;
  border-bottom: 1px solid var(--color-gray-103);
  border-radius: 0;
  padding: 8px 0;
  margin-top: 0px;
  `}

  ${({ $preventInput }) =>
    $preventInput ? `caret-color: transparent; cursor: not-allowed;` : ``}
`

const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
interface IProps extends InputProps {
  title?: string
  children?: ReactNode
  placeholder?: string
  required?: boolean
  fixed?: number
  preventInput?: boolean
  defaultStyle?: boolean
  numberInputRef?: any
}

const InputNumber = (props: IProps) => {
  const { t } = useTranslation()
  const { getNumberCommasFixed, getNumberFromNumberCommas } = useFormatData()
  const {
    title,
    fixed,
    required,
    placeholder,
    preventInput,
    value,
    onChange,
    defaultStyle,
    max,
    numberInputRef,
    ...resPros
  } = props
  const [valuePrivate, setValuePrivate] = useState('')
  const preventInputRef = useRef(false)
  const inputKey = useRef('')
  const preValueRef = useRef('')
  const isTelex = useRef(false)
  const isRemove = useRef(false)

  useEffect(() => {
    if (value) setValuePrivate(getNumberCommasFixed(value))
  }, [value])

  const handleOnChange = (e: any) => {
    if (isTelex.current) return
    let numStr = e.target?.value?.replace(NOT_NUMBER_COMMA, '')

    let numberCommas = getNumberCommasFixed(numStr)
    if (
      getNumberFromNumberCommas(preValueRef.current) &&
      max &&
      (getNumberFromNumberCommas(preValueRef.current) || 0) > Number(max) &&
      !isRemove.current
    ) {
      numberCommas = getNumberCommasFixed(preValueRef.current, fixed)
      numStr = preValueRef.current
    }
    preValueRef.current = numStr

    setValuePrivate(numberCommas)

    if (onChange) {
      const value =
        (getNumberFromNumberCommas(numberCommas) as any) > 0
          ? (getNumberFromNumberCommas(numberCommas) as any)
          : ''
      onChange(value)
    }
  }

  const handleOnChangeTelex = (isRemove?: boolean) => {
    if (preventInputRef.current) return

    let numStr = ''
    if (inputKey.current) {
      numStr = preValueRef.current + inputKey.current
    }
    if (isRemove) {
      numStr = preValueRef.current?.slice(0, preValueRef.current.length - 1)
    }
    let numberCommas = getNumberCommasFixed(numStr)
    if (
      getNumberFromNumberCommas(preValueRef.current) &&
      max &&
      (getNumberFromNumberCommas(preValueRef.current) || 0) > Number(max) &&
      !isRemove
    ) {
      numberCommas = getNumberCommasFixed(preValueRef.current, fixed)
      numStr = preValueRef.current
    }
    setValuePrivate(numberCommas)
    preValueRef.current = numStr
    if (onChange) {
      const value =
        (getNumberFromNumberCommas(numberCommas) as any) > 0
          ? (getNumberFromNumberCommas(numberCommas) as any)
          : ''
      onChange(value)
    }
  }
  const handleKeyDown = (e: any) => {
    preventInputRef.current = false
    if (preventInput) e.preventDefault()
    if (e.key === ',') e.preventDefault()
    if (fixed === 0 && e.key === '.') e.preventDefault()
    if (valuePrivate.includes('.') && e.key === '.') e.preventDefault()
    isTelex.current = e.key === 'Process'
    isRemove.current = e.code === 'Backspace'
    if (isTelex.current) {
      handleKeyDownTelex(e)
    }
  }

  const handleKeyDownTelex = (e: any) => {
    if (Number(max) < (getNumberFromNumberCommas(valuePrivate) as any)) {
      preventInputRef.current = true
      if (e.code === 'Backspace') {
        preventInputRef.current = false
        handleOnChangeTelex(true)
      }
      return
    }
    if (e.key === 'Process') {
      if (!e.code?.toLowerCase()?.includes('digit')) {
        preventInputRef.current = true
        e.preventDefault()
        inputKey.current = ''
        handleOnChangeTelex()
        return
      } else {
        isTelex.current = true
        inputKey.current = e.code?.toLowerCase()?.replace('digit', '')
        handleOnChangeTelex()
      }
    } else {
      inputKey.current = ''
      if (e.code === 'Backspace') {
        preventInputRef.current = false
        handleOnChangeTelex(true)
      }
    }
  }
  const handleOnBlur = () => {
    // const numberCommas = getNumberCommasFixed(valuePrivate, fixed)
    // setValuePrivate(numberCommas)
    // if (onChange) onChange(getNumberFromNumberCommas(numberCommas) as any)
  }
  return (
    <>
      <StyledLabel>
        {t(title || '')} {required && <span>*</span>}
      </StyledLabel>
      <StyledInput
        $preventInput={preventInput}
        $defaultStyled={defaultStyle}
        placeholder={t(placeholder || '')}
        onKeyDown={handleKeyDown}
        onBlur={handleOnBlur}
        onChange={handleOnChange}
        value={valuePrivate}
        ref={numberInputRef}
        {...resPros}
      />
    </>
  )
}

export default InputNumber
